export default {"src":"/_next/static/media/error.23d54564.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};